import { PRIVACY_POLICY_URL } from './urls';

export const DOC_VERIFICATION_STEP_TITLE = 'Realiza el cálculo en solo 2 pasos';

export const DOC_VERIFICATION_REQUIREMENTS = (basketBasicAmount = '') => ([
  `Aquí puedes calcular el monto que necesitas para lograr tu pensión mínima objetivo. Recuerda que está pensión mensual no puede ser menor a la Canasta Básica de Consumo fijada por el INEI (${basketBasicAmount}).*`,
]);

export const DOC_LEGAL_RESOLUTION = '* Cálculo realizado de acuerdo con lo establecido en la Resolución SBS Nº 01485-2023';

export const DOC_VERIFICATION_LABEL_INPUT = 'Ingresa tu número de documento de identidad';

export const DOC_VERIFICATION_PRIVACY_POLICY = `Todos tus datos personales serán tratados conforme a nuestra <a href="${ PRIVACY_POLICY_URL }" target="_blank" rel="noopener noreferrer">Política de Privacidad</a>`;

export const DOC_VERIFICATION_BTN = {
  VALIDATE: 'Validar',
  VALIDATING: 'Validando',
}